const env = process.env;

const dev = {
  BASE_URL: env.REACT_APP_BASE_URL,
  SUBSCRIPTION_KEY: env.REACT_APP_SUBSCRIPTION_KEY,
  API_TENANT: env.REACT_APP_API_TENANT,
  B2C_CLIENT_ID: env.REACT_APP_B2C_CLIENT_ID,
  B2C_AUTHORITY: env.REACT_APP_B2C_AUTHORITY,
  B2C_GOOGLE_AUTHORITY: env.REACT_APP_B2C_GOOGLE_AUTHORITY,
  B2C_KNOW_AUTHORITIES: [env.REACT_APP_B2C_KNOW_AUTHORITIES],
  B2C_REDIRECT_URI: env.REACT_APP_B2C_REDIRECT_URI,
  B2C_POST_LOGOUT_REDIRECT_URI: env.REACT_APP_B2C_POST_LOGOUT_REDIRECT_URI,
  B2C_SCOPES: env.REACT_APP_B2C_SCOPES,
  B2C_SIGN_UP_IN_AUTHORITY: env.REACT_APP_B2C_SIGN_UP_IN_AUTHORITY,
  B2C_PAYLINK_PASSWORDLESS_AUTHORITY:
    env.REACT_APP_B2C_PAYLINK_PASSWORDLESS_AUTHORITY,
  B2C_FORGOT_PASSWORD_AUTHORITY: env.REACT_APP_B2C_FORGOT_PASSWORD_AUTHORITY,
  B2C_EDIT_PROFILE_AUTHORITY: env.REACT_APP_B2C_EDIT_PROFILE_AUTHORITY,
  B2C_AUTHORITY_DOMAIN: env.REACT_APP_B2C_AUTHORITY_DOMAIN,
  SITE_LINKS: {
    merchant: "https://localhost:3000",
    marketplace: "https://localhost:2401",
    checkout: "/",
    webSales: "https://localhost:2403",
  },
  PAYSTACK_SECRET_KEY: process.env.REACT_APP_PAYSTACK,

  PAYCURRA_ADMIN_URN: "51763dbddf8950ff84219582bd77203c",

  PAYCURRA_CONSUMER_CUSTOMER_URN: "1f493d8b-PAY-CURRA-321c5a982e62",

  // Waiting list
  WAITING_LIST_ILLUSTRATION_1:
    "https://clbsinteuwpycinfrablob.blob.core.windows.net/paycurra/waitlist-illustrations/paycurra-campaign-planning.png",
  WAITING_LIST_ILLUSTRATION_2:
    "https://clbsinteuwpycinfrablob.blob.core.windows.net/paycurra/waitlist-illustrations/paycurra-wallet.png",
  WAITING_LIST_ILLUSTRATION_3:
    "https://clbsinteuwpycinfrablob.blob.core.windows.net/paycurra/waitlist-illustrations/paycurra-shopfront.png",

  // App Stores
  APP_STORE: {
    google: "https://play.google.com/store/apps/details?id=com.paycurra.wallet",
    apple: "https://apps.apple.com/ng/app/paycurra/id6742070834",
  },
};

const prod = {
  BASE_URL: "https://pyc-prd-eun-apim.azure-api.net",
  SUBSCRIPTION_KEY: "52dbce5c1e43416bb4fce4e04c43cbcb",
  API_TENANT: env.REACT_APP_API_TENANT,
  B2C_CLIENT_ID: "4c66627f-87d3-44c8-9f8f-2ff6423714d6",
  B2C_AUTHORITY:
    "https://pycprdeuncnsmr.b2clogin.com/pycprdeuncnsmr.onmicrosoft.com/B2C_1A_PYC_CONSMR_CHKO_SIGNIN",
  B2C_GOOGLE_AUTHORITY:
    "https://pycprdeuncnsmr.b2clogin.com/pycprdeuncnsmr.onmicrosoft.com/B2C_1A_PYC_CONSMR_GOOGLE_SIGNUP_SIGNIN",
  B2C_KNOW_AUTHORITIES: ["pycprdeuncnsmr.b2clogin.com"],
  B2C_REDIRECT_URI: "https://checkout.paycurra.com/loginComplete",
  B2C_POST_LOGOUT_REDIRECT_URI:
    "https://checkout.paycurra.com/logout",
  B2C_SCOPES:
    "https://pycprdeuncnsmr.onmicrosoft.com/api://identityexperienceframework/user_impersonation openid",
  B2C_SIGN_UP_IN_AUTHORITY:
    "https://pycprdeuncnsmr.b2clogin.com/dfbba46d-1fe1-434b-9acf-bd61644d27b4/B2C_1A_PYC_CONSMR_SIGNUP_SIGNIN",
  B2C_PAYLINK_PASSWORDLESS_AUTHORITY:
    "https://pycprdeuncnsmr.b2clogin.com/pycprdeuncnsmr.onmicrosoft.com/B2C_1A_PYC_CONSMR_PASSWORDLESS_SIGNIN",
  B2C_FORGOT_PASSWORD_AUTHORITY:
    "https://pycprdeuncnsmr.b2clogin.com/dfbba46d-1fe1-434b-9acf-bd61644d27b4/B2C_1A_PYC_CONSMR_PASSWORDRESET",
  B2C_EDIT_PROFILE_AUTHORITY:
    "https://pycprdeuncnsmr.b2clogin.com/dfbba46d-1fe1-434b-9acf-bd61644d27b4/B2C_1A_PYC_CONSMR_PROFILEEDIT",
  B2C_AUTHORITY_DOMAIN: "pycprdeuncnsmr.b2clogin.com",
  SITE_LINKS: {
    merchant: "https://merchant.paycurra.com",
    marketplace: "https://www.paycurra.store",
    checkout: "https://checkout.paycurra.com",
    webSales: "https://www.paycurra.com",
  },
  PAYSTACK_SECRET_KEY: process.env.REACT_APP_PAYSTACK,

  PAYCURRA_ADMIN_URN: "eb0724df5ef45e49a002c6d32a563af0",

  PAYCURRA_CONSUMER_CUSTOMER_URN: "1f493d8b-PAY-CURRA-321c5a982e62",

  // Waiting list
  WAITING_LIST_ILLUSTRATION_1:
    "https://assets.paycurra.com/paycurra/waitlist-illustrations/paycurra-campaign-planning.png",
  WAITING_LIST_ILLUSTRATION_2:
    "https://assets.paycurra.com/paycurra/waitlist-illustrations/paycurra-wallet.png",
  WAITING_LIST_ILLUSTRATION_3:
    "https://assets.paycurra.com/paycurra/waitlist-illustrations/paycurra-shopfront.png",

  // App Stores
  APP_STORE: {
    google: "https://play.google.com/store/apps/details?id=com.paycurra.wallet",
    apple: "https://apps.apple.com/ng/app/paycurra/id6742070834",
  },
};

export const urlConfig = env.NODE_ENV === "development" ? dev : prod;
